<template>
<!--  <div>-->
    <div ref="editor" :style="{width: width, height: '100%'}"></div>
<!--    <div class="statusbar" ref="statusBar" :style="{width: '100%'}"></div>-->
<!--  </div>-->
</template>

<script>
import ace from 'ace-builds/src-noconflict/ace'
import 'ace-builds/webpack-resolver'
import '../js/ace/webpack-resolver'
import * as Mousetrap from 'mousetrap'
import * as ResizeSensor from 'css-element-queries/src/ResizeSensor'
import { chooseSessionWithDialog } from '../js/noteTemplates/sessionsUiHelper'
// import StatusBar from 'ace-builds/src-noconflict/ext-statusbar'

// import ace from 'brace'
export default {
  name: 'ace-vue',
  props: {
    content: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: 'javascript'
    },
    theme: {
      type: String,
      default: 'chrome'
    },
    height: {
      type: String,
      default: '400px'
    },
    width: {
      type: String,
      default: 'auto'
    },
    sync: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function () { return {} }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      skipNextChange: false,
      resizeSensor: null,
      editor: null,
      mousetrap: null
    }
  },

  mounted: function () {
    const vm = this
    const lang = this.lang
    const theme = this.theme
    // var editor = this.editor = ace.edit(vm.$el)
    let editor = this.editor = ace.edit(this.$refs['editor'])
    // this.statusBar = new StatusBar.StatusBar(editor, this.$refs['statusBar'])
    // var options = this.options
    editor.$blockScrolling = Infinity
    editor.getSession().setMode('ace/mode/' + lang)
    editor.setTheme('ace/theme/' + theme)
    editor.setValue(vm.content, 1)
    this.updateOptions()
    this.mousetrap = new Mousetrap(this.$el)
    this.mousetrap.bind(['ctrl+shift+s'], () => {
      chooseSessionWithDialog()
      // return false to prevent default browser behavior
      // and stop event from bubbling
      return false
    })
    // Basically, mousetrap works unless ace already has the key bound.  Then it's 'overridden'
    // this.mousetrap.bind(['ctrl+shift+f'], () => {
    //   console.log('double shifaaaaaat!!')
    //
    //   // return false to prevent default browser behavior
    //   // and stop event from bubbling
    //   return false
    // })
    editor.commands.bindKeys({ 'ctrl-shift-f': () => {
      console.log('command shift f')
      this.$store.dispatch('openSearchDialog', '')
    } })
    editor.setHighlightActiveLine(true)
    // editor.enable_spellcheck()
    // editor.setReadOnly(this.readOnly)
    editor.on('change', function () {
      if (vm.skipNextChange) {
        vm.skipNextChange = false
        return
      }
      vm.$emit('change', editor.getValue())
    })
    editor.on('copy', function (str) {
      vm.$emit('copy', str)
    })
    editor.on('paste', function () {
      vm.$emit('paste')
    })
    editor.session.on('changeScrollTop', function (e) {
      vm.$emit('scrollV', e)
    })
    editor.session.on('changeScrollLeft', function (e) {
      vm.$emit('scrollH', e)
    })

    // vm.resizeSensor = new ResizeSensor(vm.$el, function () {
    vm.resizeSensor = new ResizeSensor(this.$refs['editor'], function () {
      // console.log('Changed to ' + vm.$el.clientWidth)
      vm.updateEditorWrapping()
    })
  },
  watch: {
    'content': function (newContent) {
      if (this.sync) {
        if (this.editor.getValue() === newContent) return
        this.skipNextChange = true
        const pos = this.editor.session.selection.toJSON()
        this.editor.setValue(newContent)
        this.editor.session.selection.fromJSON(pos)
      }
    },
    'lang': function () {
      this.editor.getSession().setMode('ace/mode/' + this.lang)
    },
    theme: function (newTheme) {
      this.editor.setTheme('ace/theme/' + newTheme)
    },
    options: function (newOpts) {
      this.options = newOpts
      this.updateOptions()
    }
  },
  methods: {
    getValue: function () {
      return this.editor.getValue()
    },
    setValue: function (newContent) {
      this.skipNextChange = true
      this.editor.setValue(newContent, 1)
      this.editor.resize(true)
      this.$nextTick(() => {
        this.updateEditorWrapping()
      })
    },
    updateEditorWrapping () {
      let characterWidth = this.editor.renderer.characterWidth
      let contentWidth = this.editor.renderer.scroller.clientWidth
      this.editor.session.setWrapLimit(parseInt(contentWidth / characterWidth - 1, 10))
    },
    updateOptions () {
      if ('theme' in this.options) {
        if (!(this.options.theme.startsWith('ace/'))) {
          this.options.theme = 'ace/theme/' + this.options.theme
        }
      }
      if ('mode' in this.options) {
        if (!(this.options.mode.startsWith('ace/'))) {
          this.options.mode = 'ace/mode/' + this.options.mode
        }
      }
      if ('keyboardHandler' in this.options) {
        if (this.options.keyboardHandler === 'ace') {
          this.options.keyboardHandler = null
        }
        if (this.options.keyboardHandler !== null &&
          !(this.options.keyboardHandler.startsWith('ace/keyboard/'))) {
          this.options.keyboardHandler = 'ace/keyboard/' + this.options.keyboardHandler
        }
        this.editor.setKeyboardHandler(this.options.keyboardHandler)
      }
      this.editor.setOptions(this.options)
    }
  }
}
</script>

<style scoped>
  .statusbar {
    margin: 0;
    padding: 1.5px;
    /*position: absolute;*/
    left: 0;
    right: 0;
    bottom: 0;
    height: 20px;
    background-color: #272822;
    color: white;
  }
</style>
